import { render, staticRenderFns } from "./licenseManagement.vue?vue&type=template&id=47148542&scoped=true"
import script from "./licenseManagement.vue?vue&type=script&lang=js"
export * from "./licenseManagement.vue?vue&type=script&lang=js"
import style0 from "./licenseManagement.vue?vue&type=style&index=0&id=47148542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47148542",
  null
  
)

export default component.exports